/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ConsentimentosAliases {
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CUSTOM_CARD_CONSENTIMENTOS = 'custom-card-consentimentos',
  DECK = 'deck',
  FETCH = 'fetch',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  LAYOUT_CONSENTIMENTOS = 'layout-consentimentos',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
}
export { ConsentimentosAliases };
